import React from "react";
import { motion } from "framer-motion";
import Separator from "../../../../../../core/components/Separator.tsx";
import Checkbox from "../../../../../../core/data-entry/Checkbox.tsx";

export interface RenderCheckboxProps {
	title: string;
	options: { label: string; checked: boolean; onCheck: () => void }[];
}

export const RenderLateralCheckbox = ({
	title,
	options,
}: RenderCheckboxProps) => {
	return (
		<div className="modal-filtros-viagens-select-lateral-boxes-container">
			<p className="modal-filtros-viagens-select-lateral-boxes-title">
				{title}
			</p>
			<Separator size="xs" />
			<div className="modal-filtros-viagens-lateral-checkboxes">
				{options.map((option) => (
					<motion.div
						key={option.label}
						className="modal-filtros-viagens-lateral-checkbox"
						initial={{ opacity: 0 }}
						animate={{ opacity: option.checked ? 1 : 0.5 }}
						whileHover={{ opacity: 1 }}
						transition={{ duration: 0.3 }}
						onClick={option.onCheck}
					>
						<Checkbox checked={option.checked} onCheck={option.onCheck} />
						<Separator direction="horizontal" size="xs" />
						<p>{option.label}</p>
					</motion.div>
				))}
			</div>
		</div>
	);
};

export const RenderCheckbox = ({ title, options }: RenderCheckboxProps) => {
	return (
		<div className="modal-filtros-viagens-select-boxes-container">
			<p className="modal-filtros-viagens-select-boxes-title">{title}</p>
			<Separator size="xs" />
			<div className="modal-filtros-viagens-checkboxes">
				{options.map((option) => (
					<motion.div
						key={option.label}
						className="modal-filtros-viagens-checkbox"
						initial={{ opacity: 0 }}
						animate={{ opacity: option.checked ? 1 : 0.5 }}
						whileHover={{ opacity: 1 }}
						transition={{ duration: 0.3 }}
						onClick={option.onCheck}
					>
						<Checkbox checked={option.checked} onCheck={option.onCheck} />
						<p>{option.label}</p>
					</motion.div>
				))}
			</div>
		</div>
	);
};
